import { ScheduleEntryState } from '@griply/types';

export enum TaskCompletionTransition {
  Uncomplete = 'uncomplete',
  Skip = 'skip',
  Unskip = 'unskip',
  Fail = 'fail',
  Unfail = 'unfail',
}

export type GetHabitTrackingTransitionsOptions = {
  priorState: ScheduleEntryState | undefined;
  type: ScheduleEntryState;
  shouldUncompleteHabit: boolean;
};

export const getHabitTrackingTransitions = ({
  priorState,
  type,
  shouldUncompleteHabit,
}: GetHabitTrackingTransitionsOptions): TaskCompletionTransition[] => {
  const transitions: TaskCompletionTransition[] = [];

  if (type === ScheduleEntryState.Skip) {
    priorState !== ScheduleEntryState.Skip &&
      transitions.push(TaskCompletionTransition.Skip);
    return transitions;
  }

  if (type === ScheduleEntryState.Failure) {
    priorState !== ScheduleEntryState.Failure &&
      transitions.push(TaskCompletionTransition.Fail);
    return transitions;
  }

  if (priorState === ScheduleEntryState.Skip) {
    transitions.push(TaskCompletionTransition.Unskip);
  }
  if (priorState === ScheduleEntryState.Failure) {
    transitions.push(TaskCompletionTransition.Unfail);
  }
  if (shouldUncompleteHabit) {
    transitions.push(TaskCompletionTransition.Uncomplete);
  }

  return transitions;
};
